import { createAction, props } from '@ngrx/store';
import { IPaymentRunSummary } from '../dto/pyament-run.dto';

export const loadPaymentRunSummary = createAction(
  '[PaymentRun] Load PaymentRun Summary',
  props<{
    request: {
      businessId: string;
      businessPaymentRunId : string;
    };
  }>()
);

export const loadPaymentRunSummarySuccess = createAction('[PaymentRun] Load PaymentRun Summary Success', props<{response: IPaymentRunSummary}>());

export const loadPaymentRunSummaryFailure = createAction('[PaymentRun] Load PaymentRun Summary Failure', props<{ error: Error | any }>());
